module.exports = __webpack_public_path__ + "img/a1_2.e1c74095.jpg";